<div class="row header qm-bg-primary-linear-gradient">
  <div class="container-fluid px-5">
    <!-- after login menu -->
    @if (loginService.isLogin()) {
      <nav class="navbar navbar-expand-lg px-0 py-4 align-items-end">
        <a [routerLink]="['/dashboard']" class="navbar-brand w-50">
          <img width="500" src="../../../assets/images/qm-logos/Quotemonster-IGA-Logo.png?v=2" alt="qm-logo" />
        </a>
        <button
          mat-icon-button
          [disableRipple]="true"
          class="navbar-toggler qm-scale-150"
          type="button"
          data-toggle="collapse"
          aria-expanded="false"
          aria-label="Toggle navigation">
          <span
            class="material-icons navbar-toggler-icon qm-qm-text-white"
            aria-hidden="false"
            aria-label="menu"
            (click)="showCollapseNav = !showCollapseNav">
            menu
          </span>
        </button>
        <div
          class="collapse navbar-collapse justify-content-between align-items-center"
          [ngClass]="{ 'show border-top pb-5 mt-3': showCollapseNav }">
          <ul class="navbar-nav align-items-center">
            <li class="nav-item px-2">
              <a
                [routerLink]="['/group-members']"
                class="nav-link qm-text-lg fw-bold text-nowrap"
                [routerLinkActive]="['link-active']"
                (click)="showCollapseNav = false; loginService.doGoogleTracking('InternalGroupAdminNavMenu', 'groupMembers', '')">
                Members
              </a>
            </li>
            <li class="nav-item px-4">
              <a
                [routerLink]="['/view-invoice']"
                class="nav-link qm-text-lg fw-bold text-nowrap"
                [routerLinkActive]="['link-active']"
                (click)="showCollapseNav = false; loginService.doGoogleTracking('InternalGroupAdminNavMenu', 'viewInvoice', '')">
                Invoice
              </a>
            </li>
            <li class="nav-item px-2">
              <a
                [routerLink]="['/soa-template']"
                class="nav-link qm-text-lg fw-bold text-nowrap"
                [routerLinkActive]="['link-active']"
                (click)="showCollapseNav = false; loginService.doGoogleTracking('InternalGroupAdminNavMenu', 'soaTemplate', '')">
                SOA
              </a>
            </li>
          </ul>
          <button
            mat-button
            class="qm-white-theme qm-btn-lg text-nowrap"
            aria-label="logout"
            (click)="logout(); loginService.doGoogleTracking('InternalGroupAdminNavMenu', 'logout', '')"
            title="logout"
            [ngClass]="{ 'w-100': showCollapseNav }">
            <span class="d-flex align-items-center">
              <span class="me-3 qm-text-transform-none qm-text-lg">{{ loginService.getCurrentLoginUserName() }}</span>
              <span class="material-icons">logout</span>
            </span>
          </button>
        </div>
      </nav>
    }

    <!--before login menu-->
    @if (loginService.isLogin() === false) {
      <nav class="navbar navbar-expand-lg px-0 py-4 align-items-end">
        <a [routerLink]="['/home']" class="navbar-brand w-75">
          <img width="500" src="../../../assets/images/qm-logos/Quotemonster-IGA-Logo.png?v=2" alt="qm-logo" />
        </a>
      </nav>
    }
  </div>
</div>
